import { render } from "./OldList.vue?vue&type=template&id=cf1b3ece"
import script from "./OldList.vue?vue&type=script&lang=js"
export * from "./OldList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__